import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { HttpClient, HttpParams } from '@angular/common/http';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class NewsService {
  private baseUrl = environment.apiUrl;
  private endpointBase = "/api/News/";
  data: any = {}


  constructor(private http: HttpClient) {}

  getTopNews(): Observable<any[]> {
      return this.http.get<any[]>(`${this.baseUrl}${this.endpointBase}get_top5_news`)
        .pipe(
          map((response: any[]) => {
            return response;
          })
        );
    }
    
    getArchives(): Observable<any[]> {
      return this.http.get<any[]>(`${this.baseUrl}${this.endpointBase}get_news_archives`)
        .pipe(
          map((response: any[]) => {
            return response;
          })
        );
    }

    getCategories(): Observable<any[]> {
      return this.http.get<any[]>(`${this.baseUrl}${this.endpointBase}get_news_categories`)
        .pipe(
          map((response: any[]) => {
            return response;
          })
        );
    }


    getNewsByArchive(page: number, pageSize: number, search: string = '08-2024'): Observable<{ data: any[]; totalCount: number }> {
    var params = new HttpParams()
      .set('page', page.toString())
      .set('pageSize', pageSize.toString())
      .set('search', search)

    return this.http.get<any>(`${this.baseUrl}${this.endpointBase}get_news_by_archive`, { params });
  }

  getNewsByCategory(page: number, pageSize: number, search: string = ''): Observable<{ data: any[]; totalCount: number }> {
    var params = new HttpParams()
      .set('page', page.toString())
      .set('pageSize', pageSize.toString())
      .set('search', search)

    return this.http.get<any>(`${this.baseUrl}${this.endpointBase}get_news_by_category`, { params });
  }
 
  getNewsByTitleOrContent(page: number, pageSize: number, search: string = ''): Observable<{ data: any[]; totalCount: number }> {
    var params = new HttpParams()
      .set('page', page.toString())
      .set('pageSize', pageSize.toString())
      .set('search', search)
    return this.http.get<any>(`${this.baseUrl}${this.endpointBase}get_news_by_title_and_content`, { params });
  }
 

  getNewsAndCountById(id:string): Observable<any> {
    return this.http.get<any>(`${this.baseUrl}${this.endpointBase}get_news_and_count_by_id?id=${id}`)
      .pipe(
        map((response: any) => {
          return response;
        })
      );
  }


}
